<template>
    <div class="page">
        <p>
                {{ creditBureau.address_name }}
                <br />
                {{ creditBureau.street_address }}
                <br />
                {{ creditBureau.city }}, {{ creditBureau.state_abbrev }} {{ creditBureau.zipcode }}
            <br />
            <br />
            Date: {{ date }}
            <br />
            <br />
            <strong>RE: Account(s):</strong>
            <template v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }},
                </template>
                <template v-else>
                    {{ creditor.account_number }},
                </template>
            </template>
            <br />
            <strong>RE: Notice of Intent to Sue</strong>
            <br />
            <br />

            To Whom It May Concern:
        </p>
        <p class="letter-content">
            This letter is simply to notify you of my intent to sue your company for the
            persistent violations of my consumer rights per the Fair Credit Reporting Act
            and Federal Trade Commission as well as to give you one last chance to remove
            these erroneous accounts from my credit report immediately.
        </p>
        <p class="letter-content">
            1. Proof of repeated attempts to dispute and resolve this frivolous account
            directly with your agency over the past several months. I have copies of the
            several dispute letters sent to and received by you.
            <br />
            2. Proof of your repeated frivolous “Verified” responses. I have proof from
            these data furnishers stating that you never contacted them to investigate.
            <br />
            3. Proof of your refusal to sufficiently investigate, including recorded phone
            calls that can be used in a court of law.
            <br />
            4. Proof that you have refused to forward ALL proof and documentation that I
            have provided to you for the data furnisher in regards to my dispute.
            <br />
            5. Proof of your repeated violations to continue sharing and profiting from
            inaccurate, incomplete, and unverifiable information about me to potential
            creditors.
        </p>
        <p class="letter-content">
            I have all the proof that I need to take you to court and win as, by law, you are
            not allowed to report this information as you have been, especially for a debt
            that is NOT MINE.
        </p>
        <p class="letter-content">
            Therefore, I have every right to take you to court to seek damages for what you
            have put me through. However, it would be more beneficial to me to have this
            account removed sooner than later and thus, the reason for me giving you,
            literally, ONE MORE CHANCE to do the right thing and resolve this matter outside
            of court, saving you more than approximately $10,000.
        </p>
        <p class="letter-content">
            I've counted at least 10 violations of my rights to date and most of which, you
            have violated on multiple occasions so if I do pursue legal ramifications, then
            you will not only be looking at FINES of $1,000 per occurrence (totaling
            $10,000-$20,000), but you will also be looking at whatever monetary damages that
            the court sees fit to award me, including legal fees.
        </p>
        <p class="letter-content">
            Please do the right thing and remove these inaccurate accounts from my credit
            reports within the next 15 days and I will NOT move forward with my intent to
            sue.
            OR … you can simply ignore this letter, as you have repeatedly done so in the
            past, tacking onto the repeated violations you've already made, and take this
            thing to court where we will settle it there.
        </p>
        <p class="letter-content">
            If I do not hear from you within the next 15 days, then I will simply check my
            credit report again in 15 days. And if you are still reporting inaccuracies at
            that time, then I will have to assume that you have chosen to ignore my requests
            for a resolution to this erroneous information yet, once again.
        </p>
        <p class="letter-content">
            Please note that this letter is being sent by both fax (for expedition) and
            certified mail (for proof of receipt) and, just like the previous
            correspondences
            between you and I, will be tracked and may be used against you. Your response to
            this letter is urgent and humbly requested within the next 15 days.
        </p>
        <p>
            Thank You,
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore()
            };
        }
    };
</script>